import styled, { css, keyframes } from "styled-components";

const animationSpinner = keyframes`
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
`;

export const Container = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	position: relative;
`;

export const Input = styled.input`
	width: 100%;
  padding: 0.75rem;
  border-radius: var(--border-radius);
  border: 1px solid var(--gray-200);
`;

export const Button = styled.button`
	height: 100%;
	background: var(--mainTheme);
	padding: 0.4rem 0;
	min-width: 3rem;
	border-radius: var(--border-radius);
	border: none;
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 0 0.1rem;
	position: absolute;
	right: -1px;

	svg { 
		${(props) => props.isLoading && css`cursor: not-allowed; animation: ${animationSpinner} 0.8s linear infinite;`} 
	}
`;
